export interface GetProductsRequest {
  productCategoryId?: number;
  filter?: string;
}
export interface GetProductsCategoryRequest {
  parentCategoryId?: number;
}
export interface GetProductsCategoryResponse {
  bannerData: string;
  id: number;
  items: CategoryItems[];
  title: string;
  categoryPath: Properties[];
}

export interface CategoryItems {
  id: number;
  parentCategoryId: number;
  title: string;
  imageData: string;
  hasChildCategory: boolean;
  hasProduct: boolean;
}
export interface GetProductsResponse {
  products: GetProductsModel[];
  categoryPath: Properties[];
}
export interface GetProductsModel {
  categoryPath: Properties[];
  // id: number;
  key: string;
  title: string;
  englishTitle: string;
  imageData: string;
  expirationDate: Date;
  expirationDate_Persian: string;
  unitPrice: number;
  count: number;
}
export interface SearchProductsResponse {
  foundAny: boolean;
  searchResult: SearchResult[];
}

export interface SearchResult {
  productCategoryId: number;
  filter: string;
  productCategoryPath: { key: number; value: string }[];
}

export interface GetCartInfoResponse {
  totalAmount: number;
  items: CategoryItems[];
}

export interface CategoryItems {
  inventoryId: number;
  basePrice: number;
  count: number;
  availableCount: number;
  discountAmount: number;
  totalAmount: number;
  finalAmount: number;
  colorTitle: string;
  colorCode: string;
  guarantyDescription: string;
  expirationDate: Date;
  expirationDate_Persian: string;
  registerDate: Date;
  registerDate_Persian: string;
  insufficientInventory: boolean;
  orderId: number;
  title: string;
  englishTitle: string;
  finalizeExpireDate: Date;
  finalizeExpireDate_Persian: string;
  cancelDate: Date;
  cancel_Persian: string;
  orderState: string;
  orderStateTitle: string;
  trackingCode: string;
  deliveryAddress: string;
  productKey: string;
}

export interface CartItemRequest {
  inventoryId: number;
  orderId: number;
}
export interface DeleteCartItemResponse {
  isSuccess: boolean;
  validationIssues: string[];
}
export interface FinalizerOrderItemsRequest {
  deliveryAddress: string;
  recipientName: string;
  recipientPhone: string;
  recipientPostalCode: string;
  items: CartItemRequest[];
}
export interface ProductKey {
  key: string;
  orderId?: number;
}
export interface GetProductDetailResponse {
  key: string;
  title: string;
  englishTitle: string;
  brand: string;
  categoryId: number;
  categoryPath: Properties[];
  description: string;
  gallery: string[];
  properties: Properties[];
  colorOptions: ColorOptions[];
  openOrders: OpenOrder[];
}
export interface Properties {
  key: string;
  value: string;
}
export interface ColorOptions {
  inventoryId: number;
  colorTitle: string;
  colorCode: string;
}
export interface OpenOrder {
  inventoryId: number;
  basePrice: number;
  count: number;
  availableCount: number;
  discountAmount: number;
  totalAmount: number;
  finalAmount: number;
  colorTitle: string;
  colorCode: string;
  guarantyDescription: string;
  expirationDate: Date;
  expirationDate_Persian: string;
  insufficientInventory: boolean;
  orderId: number;
}

export interface GetProductPriceInfoRequest {
  orderId?: number;
  inventoryId: number;
  count: number;
}
export class StoreResponse {
  trackingCode?: string | undefined;
  isValid: boolean | undefined;
  validationIssues: string[] | undefined;
  inventoryId?: number;
  orderId?: number;
}
export class HistoryListRequest {
  pageNumber: number | undefined;
  pageSize: number | undefined;
}
export interface HistoryListResponse {
  inventoryId: number;
  basePrice: number;
  count: number;
  availableCount: number;
  discountAmount: number;
  totalAmount: number;
  finalAmount: number;
  colorTitle: string;
  colorCode: string;
  guarantyDescription: string;
  expirationDate: Date;
  expirationDate_Persian: string;
  registerDate: Date;
  registerDate_Persian: string;
  insufficientInventory: true;
  orderId: number;
  title: string;
  englishTitle: string;
  finalizeExpireDate: Date;
  finalizeExpireDate_Persian: string;
  cancelDate: Date;
  cancel_Persian: string;
  orderState: string;
  orderStateTitle: string;
  trackingCode: string;
  deliveryAddress: string;
  deliveryDate: Date;
  deliveryDate_Persian: string;
  supplierName: string;
  supplierUserName: string;
}
